import { useState } from 'react';
import type { WebLinkType } from '@/widgets/products';
import { useValueInput } from '@/shared/hooks';

interface AddWebLinkFields {
  urlInputProps: ReturnType<typeof useValueInput>;
  productIdProps: {
    value: string;
    error: boolean;
    onChange: (v: string) => void;
    onBlur: () => void;
  };
  webLinkTypeProps: {
    value: WebLinkType | '';
    error: boolean;
    onChange: (v: WebLinkType) => void;
    onBlur: () => void;
  };
}

export const useAddWebLinkFields = (): AddWebLinkFields => {
  const urlInputProps = useValueInput({
    hasError: urlHasErrorValidator,
  });
  const [productId, setProductId] = useState('');
  const [productIdTouched, setProductIdTouched] = useState(false);
  const [webLinkType, setWebLinkType] = useState<WebLinkType | ''>('');
  const [webLinkTypeTouched, setWebLinkTypeTouched] = useState(false);

  return {
    urlInputProps,
    productIdProps: {
      value: productId,
      error: productIdTouched && !productId,
      onChange: setProductId,
      onBlur: () => {
        setProductIdTouched(true);
      },
    },
    webLinkTypeProps: {
      value: webLinkType,
      error: webLinkTypeTouched && !webLinkType,
      onChange: setWebLinkType,
      onBlur: () => {
        setWebLinkTypeTouched(true);
      },
    },
  };
};

export const urlHasErrorValidator = (v: string) => {
  const error = getError(v);

  return !!error;
};

export enum URLValidatonErrorCode {
  includesProtocol = 'includes-protocol',
  invalidURL = 'invalid-url',
}

interface URLValidatonError {
  code: URLValidatonErrorCode;
}

export const getError = (value: string): URLValidatonError | undefined => {
  const protocolRegex = /^(?:https?|ftp|file|ws|wss):\/\//i;

  if (protocolRegex.test(value)) {
    return {
      code: URLValidatonErrorCode.includesProtocol,
    };
  }

  try {
    new URL(`http://${value}`);
  } catch (error) {
    return {
      code: URLValidatonErrorCode.invalidURL,
    };
  }
};
